import React from 'react';

function CircleNotice() {
    return (
        <g>
            <path d="M20.5,3.5C18.2,1.2,15.2,0,12,0C5.4,0,0,5.4,0,12c0,3.2,1.2,6.2,3.5,8.5C5.8,22.8,8.8,24,12,24c6.6,0,12-5.4,12-12
                C24,8.8,22.8,5.8,20.5,3.5z M12,23c-2.9,0-5.7-1.1-7.7-3.2S1,14.9,1,12C1,6,6,1,12,1c2.9,0,5.7,1.1,7.7,3.2S23,9.1,23,12
                C23,18,18,23,12,23z"
            />
            <path d="M12,16.7c-0.3,0-0.5,0.2-0.5,0.5v1c0,0.3,0.2,0.5,0.5,0.5s0.5-0.2,0.5-0.5v-1C12.5,16.9,12.3,16.7,12,16.7z" />
            <path d="M12,5.2c-0.3,0-0.5,0.2-0.5,0.5v9.4c0,0.3,0.2,0.5,0.5,0.5s0.5-0.2,0.5-0.5V5.7C12.5,5.5,12.3,5.2,12,5.2z" />
        </g>
    );
}

export default CircleNotice;
